export default "__VITE_ASSET__CLLZF_q6__"